<template>
	<div
		class="survey-box"
		v-if="showSurveyBox && !hideSurvey"
		@click="openSurvey"
	>
		<div class="survey-box__item">
			<Timer
				class="survey-box__timer"
				:time="remainingTime"
				:has-icon="false"
				@timerFinished="handleRightboxEnd"
			/>
		</div>
	</div>
</template>

<script lang="ts" setup>
import Timer from "@/components/Timer.vue";
import { floorNumber } from "@/utils/number";
import { surveyUrl } from "@/utils/url";
import { computed, ref } from "vue";

const endDate = new Date("2026-02-23T23:59:59");

const hideSurvey = ref<boolean>(false);

const remainingTime = computed<number>(() => {
	return floorNumber((endDate.getTime() - new Date().getTime()) / 1000);
});

const showSurveyBox = computed((): boolean => {
	return new Date() <= endDate;
});

const openSurvey = (): void => {
	if (surveyUrl === "" || surveyUrl === null) {
		return;
	}
	window.open(surveyUrl, "_blank");
};

const handleRightboxEnd = (): void => {
	hideSurvey.value = true;
};
</script>

<style lang="scss" scoped>
.survey-box {
	position: relative;
	margin-right: 0.25rem;
	width: 4.375rem;
	height: 5.625rem;
	@include clickable-element;
	@include background(
		url($path-images + "rightbox/survey-box.avif"),
		contain,
		center,
		no-repeat
	);
	z-index: 0; // IMPORTANT: to prevent notifications from being displayed over modal windows

	&__timer {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 1.313rem;
		height: 1.5rem;
		color: #f2dcb5;
		font-size: 0.75rem;
		text-align: center;
	}
}
</style>
